import { useCompanyFspVM } from "presentation/hook/Company/useCompanyFspVM";
import { useCompanyDetailTracked } from "presentation/store/Company/CompanyDetailProvider";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import NumberInputComponent from "presentation/view/components/NumberInputComponent";
import { FieldType, IFieldValue } from "veronica-ui-component/dist/component/core";

export const TierFSPAccordion = () => {
    const [companyDetailState] = useCompanyDetailTracked();
    const { firstTierFSP, secondTierFSP, tierFSPUOM } = companyDetailState.companyFspState;
    const companyFSPVM = useCompanyFspVM();
    return (
        <>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`1st Tier FSP`}
                        width='14vw'
                        fieldName={"firstTierFSP"}
                        value={firstTierFSP || ''}
                        disabled={false}
                        maxLength={5}
                        decimalPlaces={0}
                        errorMessage={companyDetailState.allFormState?.firstTierFSP}
                        onChange={(e: any) => companyFSPVM.onBulkEditFieldChange('firstTierFSP', e?.target.value)}
                    />
                </div>
            </div>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item'>
                    <NumberInputComponent
                        label={`2nd Tier FSP`}
                        width='14vw'
                        fieldName={"secondTierFSP"}
                        value={secondTierFSP || ''}
                        disabled={false}
                        maxLength={5}
                        decimalPlaces={0}
                        errorMessage={companyDetailState.allFormState?.secondTierFSP}
                        onChange={(e: any) => companyFSPVM.onBulkEditFieldChange('secondTierFSP', e?.target.value)}
                    />
                </div>
            </div>
            <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
                <div className='im-flex-row-item' style={{ width: "14vw" }}>
                    <NbisCommonField
                        errorMessages={{}}
                        isReadOnly={false}
                        isShowOptional={false}
                        readOnlyValue={tierFSPUOM}
                        fieldValue={tierFSPUOM}
                        fieldLabel={"UOM"}
                        isSaveClicked={false}
                        fieldType={FieldType.DROPDOWN}
                        fieldKey={'tierFSPUOM'}
                        maxLength={60}
                        options={companyDetailState.dynamicOptions.fspUomDropdownOptions}
                        requiredFieldList={[]}
                        onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                            companyFSPVM.onCompanyFSPFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
                </div>

            </div>
            {companyDetailState.forceRefresh && <></>}
        </>
    )
}